import axiosInstance from '../../functions/axios';
import { useEffect, useState } from 'react';
import { Theme, useTheme, createTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { DatePicker, Localization } from 'react-widgets';
import { DateLocalizer } from 'react-widgets/IntlLocalizer';
import { parseDate } from '../../functions/functions';
import {
  MenuItem,
  Button,
  Checkbox,
  FormControl,
  Select,
  SelectChangeEvent,
  InputLabel,
  OutlinedInput,
  ListItemText,
  Box,
  Tab,
  Tabs,
  Typography,
  Grid,
} from '@mui/material';

const useStyles = makeStyles({
  button: {
    height: '25px',
    margin: '0 25px 0 0',
  },
});


function DateSelector({ dayStart, setDayStart, dayEnd, setDayEnd, searchButtonClick, setLoading, buttonDisabled, setButtonDisabled }) {
  const classes = useStyles();

  return (
    <Grid item sx={4} style={{ display: 'flex', margin: '25px', alignItems: 'center', gap: '10px' }}>
      <Localization
        date={
          new DateLocalizer({
            culture: 'pl-PL',
            firstOfWeek: 1,
          })
        }
      >
        <DatePicker
          value={dayStart}
          valueEditFormat={{ dateStyle: 'long' }}
          valueDisplayFormat={{ dateStyle: 'long' }}
          placeholder='Od'
          onChange={(value) => {
            setDayStart(value);
            setButtonDisabled(!value);
            localStorage.setItem('statistics.dayStart', value);
          }}
          disableFuture={true}
        />
        <b style={{ margin: '0 10px' }}>-</b>
        <DatePicker
          value={dayEnd}
          valueEditFormat={{ dateStyle: 'long' }}
          valueDisplayFormat={{ dateStyle: 'long' }}
          placeholder='Do'
          onChange={(value) => {
            setDayEnd(value);
            setButtonDisabled(!value);
            localStorage.setItem('statistics.dayEnd', value);
          }}
          disableFuture={true}
        />
      </Localization>
      <Grid item sx={2}>
        <Button
          disabled={buttonDisabled}
          className={classes.button}
          variant='outlined'
          onClick={() => {
            setLoading(true);
            setButtonDisabled(true);
            searchButtonClick();
          }}
        >
          Szukaj
        </Button>
      </Grid>
    </Grid>
  );
}

export { DateSelector };
